import { useCallback, useRef } from "react";
import useAudioTrackMonitor from "./useAudioTrackMonitor";
import styles from "./AudioInputLevel.module.scss";

const AudioInputLevel = ({
  mediaStreamTrack,
}: {
  mediaStreamTrack?: MediaStreamTrack;
}) => {
  const levelRef = useRef<HTMLDivElement>(null);

  const onLevelChanged = useCallback((level: number) => {
    if (!levelRef.current) {
      return;
    }
    levelRef.current.style.height = `${level * 2.4}px`;
  }, []);

  useAudioTrackMonitor(mediaStreamTrack, onLevelChanged);

  return <div className={styles.level} ref={levelRef} />;
};

export default AudioInputLevel;
